/* @flow */
import * as React from 'react';

import Group from 'entities/Group';
import StreamSectionListItem from './StreamSectionListItem';

type Props = {
  streams: *,
  groupCode: string,
  group: Group,
};

export default class StreamSectionListBroadcasts extends React.Component<Props> {
  render() {
    const { streams, group } = this.props;

    return (
      <React.Fragment>
        {streams &&
          streams.map(stream => {
            if (stream.__typename !== 'EntityStream') {
              return null;
            }

            const streamName = stream.name === 'Everyone' ? group.getName() : stream.name;
            return (
              <StreamSectionListItem
                groupAvatar={this.props.group.getAvatarUrl() || ''}
                key={stream.uuid}
                streamUuid={stream.uuid}
                name={streamName}
                date={stream.preview ? stream.preview.sentAt : null}
                preview={stream.preview ? stream.preview.preview : null}
                url={`/classes/${this.props.groupCode}/messages/stream/${stream.uuid}`}
              />
            );
          })}
      </React.Fragment>
    );
  }
}
